export default {
  setSettings(state, data) {
    state.settings = data;
  },

  setWorkStations(state, data) {
    state.workStations = data;
  },
  setWorkStationCode(state, data) {
    state.workStationCode = data;
  },

  setWorkShifts(state, data) {
    state.workShifts = data;
  },

  setWorkShiftCode(state, data) {
    state.workShiftCode = data;
  },

  setBoms(state, data) {
    state.boms = data;
  },
  setBom(state, data) {
    state.bom = data;
  },

  setBomCode(state, data) {
    state.bomCode = data;
  },

  setBomCommodities(state, data) {
    state.bomCommodities = data;
  },

  setOrders(state, data) {
    state.orders = data;
  },
  setOrder(state, data) {
    state.order = data;
  },

  setOrderCode(state, data) {
    state.orderCode = data;
  },

  setOrderDetails(state, data) {
    state.orderDetails = data;
  },

  setOrdersSetting(state, data) {
    state.ordersSetting = data;
  },
  setOrderSetting(state, data) {
    state.orderSetting = data;
  },

  setFoilCartable(state, data) {
    state.foilCartable = data;
  },

  setFinancialProductionCartable(state, data) {
    state.financialProductionCartable = data;
  },

  setCasterCartable(state, data) {
    state.casterCartable = data;
  },

  setColdRollCartable(state, data) {
    state.coldRollCartable = data;
  },

  setSaleCartable(state, data) {
    state.saleCartable = data;
  },

  setManagerProductionCartable(state, data) {
    state.managerProductionCartable = data;
  },

  setProductionCartable(state, data) {
    state.productionCartable = data;
  },

  setSupplyAndEquipmentCartable(state, data) {
    state.supplyAndEquipmentCartable = data;
  },

  setManagerSupplyCartable(state, data) {
    state.managerSupplyCartable = data;
  },

  setFinancialSupplyCartable(state, data) {
    state.financialSupplyCartable = data;
  },

  setOrderDetailConfirmLog(state, data) {
    state.orderDetailConfirmLog = data;
  },

  setReqProduces(state, data) {
    state.reqProduces = data;
  },
  setReqProduce(state, data) {
    state.reqProduce = data;
  },

  setReqProduceDetails(state, data) {
    state.reqProduceDetails = data;
  },

  setReqProduceCode(state, data) {
    state.reqProduceCode = data;
  },

  setProduceOrderFinancialCartable(state, data) {
    state.produceOrderFinancialCartable = data;
  },

  setProduceOrderManagerCartable(state, data) {
    state.produceOrderManagerCartable = data;
  },

  setProduceOrderProcessCartable(state, data) {
    state.produceOrderProcessCartable = data;
  },

  setProduceProcesses(state, data) {
    state.produceProcesses = data;
  },
  setproduceProcess(state, data) {
    state.produceProcess = data;
  },

  setProductionReports(state, data) {
    state.productionReports = data;
  },
  setProductionReport(state, data) {
    state.productionReport = data;
  },
  setCasterProductionReports(state, data) {
    state.casterProductionReports = data;
  },

  setProductionReportCode(state, data) {
    state.productionReportCode = data;
  },

  setProductionReportCoilNumber(state, data) {
    state.productionReportCoilNumber = data;
  },

  setProductionReportMaterials(state, data) {
    state.productionReportMaterials = data;
  },

  setProductionReportReadonlyFields(state, data) {
    state.productionReportReadonlyFields = data;
  },

  setProcessTypes(state, data) {
    state.processTypes = data;
  },

  setProduceOrders(state, data) {
    state.produceOrders = data;
  },
  setProduceOrder(state, data) {
    state.produceOrder = data;
  },

  setProduceOrderCode(state, data) {
    state.produceOrderCode = data;
  },

  setProduceOrderCartable(state, data) {
    state.produceOrderCartable = data;
  },

  setSprints(state, data) {
    state.sprints = data;
  },

  setSprintCode(state, data) {
    state.sprintCode = data;
  },

  setCurrentSprint(state, data) {
    state.currentSprint = data;
  },

  setCoilCertificates(state, data) {
    state.coilCertificates = data;
  },
  setCoilCertificate(state, data) {
    state.coilCertificate = data;
  },

  setCoilCertificateCode(state, data) {
    state.coilCertificateCode = data;
  },

  setColdRollingProductionReports(state, data) {
    state.coldRollingProductionReports = data;
  },

  setFoilRollingProductionReports(state, data) {
    state.foilRollingProductionReports = data;
  },

  setQcCasters(state, data) {
    state.qcCasters = data;
  },

  setQcColdRollings(state, data) {
    state.qcColdRollings = data;
  },

  setQcFoilRollings(state, data) {
    state.qcFoilRollings = data;
  },

  setOrderCommodity(state, data) {
    state.orderCommodity = data;
  },

  setHardnesses(state, data) {
    state.hardnesses = data;
  },
  setHardnessCode(state, data) {
    state.hardnessCode = data;
  },

  setProductSurfaces(state, data) {
    state.productSurfaces = data;
  },
  setProductSurfaceCode(state, data) {
    state.productSurfaceCode = data;
  },

  setUsageGroups(state, data) {
    state.usageGroups = data;
  },
  setUsageGroupCode(state, data) {
    state.usageGroupCode = data;
  },

  setFoilUsages(state, data) {
    state.foilUsages = data;
  },
  setFoilUsageCode(state, data) {
    state.foilUsageCode = data;
  },

  setInnerCoreDiameters(state, data) {
    state.innerCoreDiameters = data;
  },
  setInnerCoreDiameterCode(state, data) {
    state.innerCoreDiameterCode = data;
  },

  setProduceOrderCastings(state, data) {
    state.produceOrderCastings = data;
  },

  setCartableCasting(state, data) {
    state.cartableCasting = data;
  },

  setCartableColdRolling(state, data) {
    state.cartableColdRolling = data;
  },

  setCartableFoilRolling(state, data) {
    state.cartableFoilRolling = data;
  },

  setManagementCartableCasting(state, data) {
    state.managementCartableCasting = data;
  },

  setManagementCartableColdRolling(state, data) {
    state.managementCartableColdRolling = data;
  },

  setManagementCartableFoilRolling(state, data) {
    state.managementCartableFoilRolling = data;
  },

  setPrintLink(state, data) {
    state.printLink = data;
  },

  setProduceOrderColdRollings(state, data) {
    state.produceOrderColdRollings = data;
  },

  setProduceOrderFoilRollings(state, data) {
    state.produceOrderFoilRollings = data;
  },

  setFurnaces(state, data) {
    state.furnaces = data;
  },
  setFurnace(state, data) {
    state.furnace = data;
  },
  setFurnaceCode(state, data) {
    state.furnaceCode = data;
  },

  setCartableLog(state, data) {
    state.cartableLog = data;
  },

};
